// extracted by mini-css-extract-plugin
export var csatScore = "_mw-5";
export var header = "_mw-1";
export var panelWrapper = "_mw-2";
export var postPreview = "_mw-3";
export var rightContent = "_mw-0";
export var wrappingText = "_mw-4";